import axios from "axios";
const baseOptions = {
    headers: {
        common: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }
};
/**
 * Creates an instance of an Axios client with the provided options.
 * Used to give each unique service it's own client
 *
 * @param options - Options used for the client
 * @returns Instance of an Axios client
 */
export default function (options) {
    return axios.create({ ...baseOptions, ...options });
}
